module.exports = __webpack_public_path__ + "img/smart5.7a5599f7.png";